<tt-page>
    <tt-calc-copy-from [params]="params"></tt-calc-copy-from>
</tt-page>
